import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputCustomField } from './InputCustomField.entity';

export class InputDocumentTemplateGroup<T extends EMode = EMode.entity> {
  /** Alias: documentClass */
  documentClass?: any;
  /** Alias: code */
  code?: any;
  /** Alias: name */
  name?: any;
  /** Alias: groupIndex */
  groupIndex?: any;
  /** Alias: customFields */
  customFields?: InputCustomField<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputDocumentTemplateGroup> = {
  documentClass: {
    alias: 'documentClass',
  },
  code: {
    alias: 'code',
  },
  name: {
    alias: 'name',
  },
  groupIndex: {
    alias: 'groupIndex',
  },
  customFields: {
    alias: 'customFields',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputDocumentTemplateGroupEntityDefinition: EntitiyDefinition<InputDocumentTemplateGroup> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputDocumentTemplateGroup',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
